import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import 'toastr/build/toastr.min.css';
import { DisplayMessage, GetFormattedDate, ExcludeSpecialCharactersFromInputTypeNumber } from '../../../../services/helpers.js';
import DelayedRedirect from '../../../../utils/DelayedRedirect';
import { Transition } from '../../../../utils/ModalHelpers';
import { Box, Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import moment from 'moment';
import { SelectTheme } from '../../../../utils/utils.js';
import { ThemeProvider } from "@material-ui/core";
import appFetch from '../../../../api/appFetch.js';
import { BookingItemsWithIdUrl, BookingItemsWithMoboOutletIdUrl } from '../../../../constants/apiUrls.js';
import ChecklistTemplateDropdown from './../../../Common/Dropdowns/ChecklistTemplateDropdown';
import ModifiedByInfo from "./../../../Common/Footers/ModifiedByInfo";
import OutletsDropdown from '../../../Common/Dropdowns/OutletsDropdown.js';
import BrandsDropdown from '../../../Common/Dropdowns/BrandsDropdown.js';
import LanguageDropdown from '../../../Common/Dropdowns/LanguageDropdown.js';
import DatePickerComponent from '../../../Common/DatePickers/DatePickerComponent.js';

export default class BookingItemsEditing extends Component {
    constructor(props) {
        super(props);

        this.state = {
            bookingItemId: this.props.bookingItemId !== undefined ? parseInt(this.props.bookingItemId) : 0,
            id: 0,
            outletId: this.props.outletId !== 0 ? parseInt(this.props.outletId) : 0,
            objectType: this.props.objectType !== undefined ? parseInt(this.props.objectType) : null,
            language: "nl",
            longDescription: "",
            isVisibleInPlanning: false,
            shortDescription: "",
            validFrom: "",
            validTill: "",
            brandId: 0,
            operationCode: "",
            price: null,
            laborTime: null,
            infoURL: "",
            isMaintenance: false,
            isB2CVisible: false,
            isQuoteItem: false,
            isKeyDropVisible: false,
            isCheckInUpselling: false,
            modifiedOn: "",
            modifiedByName: "",
            modifiedByAvatar: "",
            loading: this.props.editedBookingItemId !== undefined,
            redirect: null,
            accessibleMoboOutlets: [],
            editedBookingItemId: this.props.editedBookingItemId,
            requestInProgress: false,
            open: true,
            bookingItemWasModified: false,
            bookingItem: null,
            bookingItems: this.props.bookingItems !== undefined ? this.props.bookingItems : [],
            checklistTemplateId: 0 
        };
    }

    componentDidMount() {
        this.getBookingItemById(this.state.bookingItemId, this.state.outletId);
    }

    handleClose = () => {
        this.setState({ open: false, redirect: "/bookingitems" });
    };

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value.replace(/^\s+/, "") }, () => this.handleValidation());
    };

    handleChangeCheckBox = e => {
        this.setState({ [e.target.name]: e.target.checked }, () => this.handleValidation());
    };

    handleValidation = () => {
        //this.setState({ requestInProgress: !this.checkIfRequestIsValid(false) });
    }

    checkIfRequestIsValid(displayErrorMessage) {
        let resources = this.props.resources;
        var isValidRequest = true;

        if (this.state.shortDescription.trim().length <= 0) {
            if (displayErrorMessage) DisplayMessage(resources["InvalidShotDescription"], "error");
            isValidRequest = false;
        }

        if (this.state.validFrom === "" || this.state.validFrom === undefined) {
            if (displayErrorMessage) DisplayMessage(resources["InvalidDateFrom"], "error");
            isValidRequest = false;
        }
        if (this.state.validTill === "" || this.state.validTill === undefined) {
            if (displayErrorMessage) DisplayMessage(resources["InvalidDateTill"], "error");
            isValidRequest = false;
        }

        if (displayErrorMessage && this.state.validFrom > this.state.validTill) {
            DisplayMessage(resources["InvalidDateTill"], "error");
            isValidRequest = false;
        }

        if (displayErrorMessage && this.state.laborTime !== "" && this.state.laborTime < 0) {
            DisplayMessage(resources["InvalidLaborTime"], "error");
            isValidRequest = false;
        }

        if (this.state.price !== null && this.state.price !== undefined) {
            var filterPrice = /^\d{0,4}(\.\d{1,2})?$/;
            var isValidPrice = filterPrice.test(this.state.price);
            if (displayErrorMessage && !isValidPrice) DisplayMessage(resources["InvalidPrice"], "error");

            isValidRequest = isValidPrice;
        }

        return isValidRequest;
    }

    isValidForm = () => {
        const { shortDescription, validFrom, validTill, laborTime, price } = this.state;

        if (!shortDescription || shortDescription.trim().length === 0) {
            return false;
        }

        if (!validFrom) {
            return false;
        }

        if (!validTill) {
            return false;
        }

        const momentValidFrom = moment(validFrom, "YYYY/MM/DD");
        const momentValidTill = moment(validTill, "YYYY/MM/DD")

        if (!momentValidFrom.isValid() || !momentValidTill.isValid() || momentValidTill.isBefore(momentValidFrom)) {
            return false;
        }

        if (laborTime && laborTime < 0) {
            return false;
        }

        const priceRegex = /^\d{0,4}(\.\d{1,2})?$/

        if (price && !priceRegex.test(price)) {
            return false;
        }

        return true;
    }

    handleSubmit = () => {
        this.saveEditedBookingItem();
    }

    getBookingItemById = (bookingItemId, outletId) => {

        if (bookingItemId <= 0) {
            return;
        }

        if (this.state.bookingItems.length > 0) {
            for (let index = 0; index < this.state.bookingItems.length; index++) {
                var item = this.state.bookingItems[index];
                if (item.id === bookingItemId) {
                    this.setState({
                        brandId: item.brand != null ? item.brand.brandId : 0,
                        language: item.language,
                        shortDescription: item.shortDescription,
                        longDescription: item.longDescription,
                        validFrom: GetFormattedDate(item.validFrom),
                        validTill: GetFormattedDate(item.validTill),
                        price: item.price,
                        operationCode: item.operationCode,
                        laborTime: item.laborTime,
                        infoURL: item.infoURL,
                        isMaintenance: item.isMaintenance,
                        isB2CVisible: item.isB2CVisible,
                        isQuoteItem: item.isQuoteItem,
                        isKeyDropVisible: item.isKeyDropVisible,
                        isCheckInUpselling: item.isCheckInUpselling,
                        bookingItem: item,
                        id: item.id,
                        loading: false,
                        modifiedOn: item.updatedOn !== null ? item.updatedOn : item.createdOn,
                        modifiedByName: item.updatedBy !== null ? item.updatedBy.firstName + " " + item.updatedBy.lastName : item.createdBy.firstName + " " + item.createdBy.lastName,
                        modifiedByAvatar: item.updatedBy != null ? item.updatedBy.avatar : item.createdBy.avatar,
                        checklistTemplateId: item.checklistTemplateId,
                    });
                    break;
                }
            }
        }
        else {
            var outletParam = outletId === undefined || outletId === 0 ? null : outletId;
            this.setState({ requestInProgress: true });

            const url = BookingItemsWithMoboOutletIdUrl(outletParam);

            appFetch({
                url: url,
                onSuccess: (response) => {
                    var existsBookingItem = false;
                    var item = null;

                    response.forEach(function (row) {
                        if (row.id === bookingItemId) {
                            existsBookingItem = true;
                            item = row;
                        }
                    });

                    if (existsBookingItem) {
                        this.setState({
                            brandId: item.brand != null ? item.brand.brandId : 0,
                            language: item.language,
                            shortDescription: item.shortDescription,
                            longDescription: item.longDescription,

                            validFrom: GetFormattedDate(item.validFrom),
                            validTill: GetFormattedDate(item.validTill),
                            price: item.price,
                            operationCode: item.operationCode,
                            laborTime: item.laborTime,
                            infoURL: item.infoURL,
                            isMaintenance: item.isMaintenance,
                            isB2CVisible: item.isB2CVisible,
                            isQuoteItem: item.isQuoteItem,
                            isKeyDropVisible: item.isKeyDropVisible,
                            isCheckInUpselling: item.isCheckInUpselling,
                            bookingItem: item,
                            id: item.id,
                            loading: false,
                            modifiedOn: item.updatedOn !== null ? item.updatedOn : item.createdOn,
                            modifiedByName: item.updatedBy !== null ? item.updatedBy.firstName + " " + item.updatedBy.lastName : item.createdBy.firstName + " " + item.createdBy.lastName,
                            modifiedByAvatar: item.updatedBy != null ? item.updatedBy.avatar : item.createdBy.avatar,
                            checklistTemplateId: item.checklistTemplate.id != null ? item.checklistTemplate.id : 0,
                        });
                    }
                    else {
                        this.setState({ open: false, redirect: "/bookingitems" });
                    }
                },
                onError: (response) => {
                    for (var i = 0; i < response.errors.length; i++) {
                        DisplayMessage(response.errors[i], "error");
                    }
                },
                onFinalize: () => {
                    this.setState({ requestInProgress: false });
                }
            })
        }

        const selectedOutlet = this.props.accessibleMoboOutlets?.find(outlet => outlet.id === this.state.outletId);
        const objectType = selectedOutlet ? selectedOutlet.objectType : this.state.objectType;

        this.setState({ objectType: objectType });
    }


    saveEditedBookingItem = () => {
        let resources = this.props.resources;

        if (!this.isValidForm()) {
            return;
        }

        this.setState({ requestInProgress: true });

        const { outletId, brandId, language, shortDescription, longDescription, validFrom, validTill, price, operationCode, laborTime, isMaintenance, isB2CVisible, isQuoteItem, isKeyDropVisible, isCheckInUpselling, infoURL, checklistTemplateId } = this.state;

        var json = JSON.stringify({
            moboOutletId: outletId === 0 ? null : outletId,
            brandId: brandId === 0 ? null : brandId,
            language: language,
            shortDescription: shortDescription,
            longDescription: longDescription,
            validFrom: validFrom,
            validTill: validTill,
            price: price !== null ? parseFloat(price) : null,
            operationCode: operationCode,
            laborTime: laborTime !== null ? parseInt(laborTime) : null,
            infoURL: infoURL === "" ? null : infoURL,
            isMaintenance: isMaintenance,
            isB2CVisible: isB2CVisible,
            isQuoteItem: isQuoteItem,
            isKeyDropVisible: isKeyDropVisible,
            isCheckInUpselling: isCheckInUpselling,
            checklistTemplateId: checklistTemplateId === 0 ? null : checklistTemplateId,
        });

        const url = BookingItemsWithIdUrl(this.state.bookingItemId);

        appFetch({
            url: url,
            method: 'PUT',
            body: json,
            onSuccess: (response) => {
                if (response.id !== undefined) {
                    this.setState({
                        updateInProgress: false,
                        bookingItemWasModified: true,
                        redirect: "/bookingitems"
                    });

                    DisplayMessage(resources["BookingItemWasSaved"], "success");
                }
            },
            onError: (response) => {
                for (var i = 0; i < response.errors.length; i++) {
                    DisplayMessage(response.errors[i], "error");
                }
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    }

    handleChangeOutlet = e => {
        const selectedOutletId = parseInt(e.target.value);
        const selectedOutlet = this.props.accessibleMoboOutlets?.find(outlet => outlet.id === selectedOutletId);
        const objectType = selectedOutlet ? selectedOutlet.objectType : null;

        this.setState({ outletId: selectedOutletId, objectType: objectType, brandId: 0 });
    };

    handleValidFrom = value => {
        this.setState({ validFrom: value }, () => this.handleValidation());
    };

    handleValidTill = value => {
        this.setState({ validTill: value }, () => this.handleValidation());
    };

    handleChangeBrand = e => {
        this.setState({ brandId: parseInt(e.target.value) });
    };

    handleChangeChecklistTemplate = e => {
        this.setState({ checklistTemplateId: parseInt(e.target.value) });
    };

    renderModifiedByInfo = () => {
        if (this.state.id > 0 && this.state.modifiedOn !== null) {
          return (
            <ModifiedByInfo
              resources={this.props.resources}
              modifiedByAvatar={this.state.modifiedByAvatar}
              modifiedOn={this.state.modifiedOn}
              modifiedByName={this.state.modifiedByName}
              className="mt-3"
            />
          );
        }

        return;
    }

    handleChangeNumber = e => {
        if (e.target.value.toString().charAt(0) === '0' && e.target.value.toString().length > 1 && e.target.value.toString().charAt(1) !== ".") {
            this.setState({ [e.target.name]: e.target.value.toString().slice(1) }, () => this.handleValidation());
        }
        else {
            this.setState({ [e.target.name]: e.target.value }, () => this.handleValidation());
        }
    };

    renderForm() {
        const { validFrom, validTill, shortDescription, isMaintenance, isB2CVisible,
            isQuoteItem, brandId, operationCode, price, laborTime, outletId, language,
            longDescription, isKeyDropVisible, isCheckInUpselling, infoURL, checklistTemplateId, objectType } = this.state;
        var resources = this.props.resources;

        var helperTextShortDescription = shortDescription.trim().length <= 0 ? "helper-text-red" : "helper-text-grey";

        return (
            <Paper elevation={3} className="p-4 mt-3 mb-3">
                <Form>
                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <OutletsDropdown
                            resources={resources}
                            outlets={this.props.accessibleMoboOutlets}
                            outlet={outletId}
                            onOutletChange={this.handleChangeOutlet}
                            containerClass="col-6 helper-text-red"
                        />
                        <div className="col-3"></div>
                    </Form.Group>
                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <BrandsDropdown
                            resources={resources}
                            brand={brandId}
                            objectType={objectType}
                            onBrandChange={this.handleChangeBrand}
                            containerClass="col-6 helper-text-red"
                            onRequestStart={() => this.setState({ requestInProgress: true })}
                            onRequestEnd={() => this.setState({ requestInProgress: false })}
                        />
                        <div className="col-3"></div>
                    </Form.Group>
                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <LanguageDropdown
                            resources={resources}
                            language={language}
                            onLanguageChange={this.handleChange}
                            containerClass="col-6 helper-text-red"
                        />
                        <div className="col-3"></div>
                    </Form.Group>
                    <Form.Group className=" d-flex" >
                        <div className="col-3"></div>
                        <ThemeProvider theme={SelectTheme}>
                            <TextField className={"col-6 " + helperTextShortDescription} id="bookingitems-shortDescription"
                                value={shortDescription} label={resources["ShortDescription"]}
                                helperText={resources["InputOfShortDescriptionIsMandatory"]}
                                variant="outlined" name="shortDescription" onChange={this.handleChange} inputProps={{ maxLength: 100 }} />
                        </ThemeProvider >
                    </Form.Group>
                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <ThemeProvider theme={SelectTheme}>
                            <TextField className="col-6 " id="bookingitems-longDescription"
                                value={longDescription} label={resources["LongDescription"]}
                                variant="outlined" name="longDescription" onChange={this.handleChange} inputProps={{ maxLength: 200 }} />
                        </ThemeProvider >
                    </Form.Group>
                    <Form.Group className="d-flex"  >
                        <div className="col-3"></div>
                        <Box display="flex" justifyContent="space-between" className='col-6' padding="0" gap="15px">
                            <DatePickerComponent
                                id="dateValidFrom"
                                label={resources["ValidFrom"]}
                                value={validFrom}
                                onChange={this.handleValidFrom}
                                error={!validFrom}
                                helperText={resources["PleasePickADate"]}
                                minDate={new Date("2000-01-01")}
                                required
                            />
                            <DatePickerComponent
                                id="dateValidTill"
                                label={resources["ValidTill"]}
                                value={validTill}
                                onChange={this.handleValidTill}
                                error={!validTill}
                                helperText={resources["PleasePickADate"]}
                                minDate={new Date("2000-01-01")}
                                required
                            />
                        </Box>
                    </Form.Group>

                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <ThemeProvider theme={SelectTheme}>
                            <TextField className="col-6 helper-text-red" id="bookingitems-operationCode"
                                value={operationCode} label={resources["OperationCode"]}
                                variant="outlined" name="operationCode" onChange={this.handleChange} inputProps={{ maxLength: 25 }} />
                        </ThemeProvider >
                    </Form.Group>

                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <ThemeProvider theme={SelectTheme}>
                            <TextField className="col-6 helper-text-red" id="bookingitems-price"
                                value={price || ''} label={resources["Price"]}
                                variant="outlined" name="price" onChange={this.handleChangeNumber} type="number"
                                onKeyDown={ExcludeSpecialCharactersFromInputTypeNumber(false)}
                                inputProps={{
                                    maxLength: 6,
                                    step: "0.01"
                                }} />
                        </ThemeProvider >
                    </Form.Group>

                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <ThemeProvider theme={SelectTheme}>
                            <TextField className="col-6 helper-text-red" id="bookingitems-laborTime"
                                value={laborTime} label={resources["LaborTime"]}
                                onKeyDown={ExcludeSpecialCharactersFromInputTypeNumber(true)}
                                variant="outlined" name="laborTime" onChange={this.handleChangeNumber} type="number"
                                InputProps={{ inputProps: { min: 0 } }}
                            />
                        </ThemeProvider >
                    </Form.Group>
                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <ThemeProvider theme={SelectTheme}>
                            <TextField className="col-6 helper-text-red" id="bookingitems-infoURL"
                                value={infoURL} label={resources["InfoURL"]}
                                variant="outlined" name="infoURL" onChange={this.handleChange}
                            />
                        </ThemeProvider >
                    </Form.Group>
                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <ChecklistTemplateDropdown
                            resources={resources}
                            checklistTemplateId={checklistTemplateId}
                            onChecklistTemplateChange={this.handleChangeChecklistTemplate}
                            containerClass="col-6 text-left"
                        />
                        <div className="col-3"></div>
                    </Form.Group>
                    <Form.Group style={{ display: "flex" }} >
                        <div className="col-md-3 "> </div>
                        <FormControlLabel className="col-md-6 text-right label-mt my-auto p-0"
                            control={<Checkbox id="bookingitems-isMaintenance" checked={isMaintenance} onChange={this.handleChangeCheckBox} name="isMaintenance" color="primary" />}
                            label={resources["IsMaintenance"]} />
                        <div className="col-md-4"> </div>
                    </Form.Group>
                    <Form.Group style={{ display: "flex" }} >
                        <div className="col-md-3 "> </div>
                        <FormControlLabel className="col-md-6 text-right label-mt my-auto p-0"
                            control={<Checkbox id="bookingitems-isB2CVisible" checked={isB2CVisible} onChange={this.handleChangeCheckBox} name="isB2CVisible" color="primary" />}
                            label={resources["IsB2CVisible"]} />
                        <div className="col-md-4"> </div>
                    </Form.Group>
                    <Form.Group style={{ display: "flex" }} >
                        <div className="col-md-3 "> </div>
                        <FormControlLabel className="col-md-6 text-right label-mt my-auto p-0"
                            control={<Checkbox id="bookingitems-isQuoteItem" checked={isQuoteItem} onChange={this.handleChangeCheckBox} name="isQuoteItem" color="primary" />}
                            label={resources["IsQuoteItem"]} />
                        <div className="col-md-4"> </div>
                    </Form.Group>
                    <Form.Group style={{ display: "flex" }} >
                        <div className="col-md-3 "> </div>
                        <FormControlLabel className="col-md-6 text-right label-mt my-auto p-0"
                            control={<Checkbox id="bookingitems-isKeyDropVisible" checked={isKeyDropVisible} onChange={this.handleChangeCheckBox} name="isKeyDropVisible" color="primary" />}
                            label={resources["IsKeyDropVisible"]} />
                        <div className="col-md-4"> </div>
                    </Form.Group>
                    <Form.Group style={{ display: "flex" }} >
                        <div className="col-md-3 "> </div>
                        <FormControlLabel className="col-md-6 text-right label-mt my-auto p-0"
                            control={<Checkbox id="bookingitems-isCheckInUpselling" checked={isCheckInUpselling} onChange={this.handleChangeCheckBox} name="isCheckInUpselling" color="primary" />}
                            label={resources["IsCheckInUpselling"]} />
                        <div className="col-md-4"> </div>
                    </Form.Group>
                    {this.renderModifiedByInfo()}
                </Form>
            </Paper>
        );
    }

    renderMain() {
        const { loading } = this.state;

        if (loading) {
            return (<div className="centered-loader"><CircularProgress /></div>);
        }

        return <div className={"py-4 grey " + (this.state.loading ? 'fadeOut' : 'fadeIn')}>
            {this.renderForm()}
        </div>;
    }

    render() {
        const { redirect, open, bookingItemWasModified, outletId, requestInProgress } = this.state;
        const { resources } = this.props;

        const isSaveButtonDisabled = requestInProgress || !this.isValidForm() || redirect

        return (
            <div>
                {redirect && <DelayedRedirect to={{ pathname: redirect, state: { refreshGrid: bookingItemWasModified, outletId: outletId } }} delay={250} />}
                <Dialog fullScreen open={open} onClose={this.handleClose} TransitionComponent={Transition}>
                    <AppBar className="position-sticky">
                        <Toolbar>
                            <IconButton id="close-edit-BookingItem" edge="start" color="inherit" onClick={this.handleClose} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" style={{ flex: 1 }}>
                                {resources["EditBookingItem"]}
                            </Typography>
                            <Button id="bookingitems-save" disabled={isSaveButtonDisabled} color="inherit" onClick={this.handleSubmit}>{resources["Save"]}</Button>
                        </Toolbar>
                    </AppBar>
                    <div className="container">
                        {this.renderMain()}
                    </div>
                </Dialog>
            </div >
        );
    }
}